import React from 'react';
import Top from "../../components/Top";
import BottomForm from "./components/BottomForm";

const Register = () => {
  return (
    <div>
      <Top/>
      <BottomForm/>
    </div>
  )
};

export default Register;